<template>
  <div
    v-if="
      isRenderPlayerRegistrationFlow &&
        !allEventOptionsAtCapacity &&
        !userNotInvited
    "
    class="player-registration d-flex flex-column align-center flex-md-row align-md-start"
  >
    <PlayerRegistrationPlayerDetails
      @showPlayerAvatarCropModal="showPlayerAvatarCropModal = true"
      v-if="formStep !== 3"
    />
    <PlayerRegistrationForm
      :formStep="formStep"
      :moveToFormStep="moveToFormStep"
    />
    <PlayerAvatarCropModal
      v-if="showPlayerAvatarCropModal"
      @close="showPlayerAvatarCropModal = false"
    />
  </div>
  <PlayerRegistrationClosePage
    v-else-if="
      !isRenderPlayerRegistrationFlow ||
        allEventOptionsAtCapacity ||
        userNotInvited
    "
  />
</template>

<script>
import PlayerRegistrationPlayerDetails from "./PlayerRegistrationPlayerDetails";
import PlayerRegistrationForm from "./PlayerRegistrationForm";
import { mapActions, mapGetters } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { RegistrationStatusTypes } from "../enums/RegistrationStatusTypes";
import PlayerRegistrationClosePage from "../teamregistration/PlayerRegistrationClosePage";
import PlayerAvatarCropModal from "@/components/common/PlayerAvatarCropModal.vue";

export default {
  name: "PlayerRegistration",
  components: {
    PlayerAvatarCropModal,
    PlayerRegistrationClosePage,
    PlayerRegistrationPlayerDetails,
    PlayerRegistrationForm
  },
  data: () => ({
    formStep: 1,
    showPlayerAvatarCropModal: false
  }),

  mounted() {
    const { registrationId, orgUnitId } = this.$route.params;
    this.fetchPlayerRegistrationInfo({
      registrationId,
      orgUnitId
    });
  },

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistrationInfo",
      "allEventOptionsAtCapacity",
      "userNotInvited"
    ]),

    isRenderPlayerRegistrationFlow() {
      return (
        this.playerRegistrationInfo?.registrationStatus ===
        RegistrationStatusTypes.OPEN
      );
    }
  },

  methods: {
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "fetchPlayerRegistrationInfo"
    ]),
    moveToFormStep(value) {
      this.formStep = value;
    }
  }
};
</script>

<style scoped>
.player-registration {
  padding-top: 60px;
  flex-grow: 1;
  width: 100%;
  max-width: 1500px;
  margin-top: 51px;
}
@media (min-width: 960px) {
  .player-registration {
    margin-top: 88px;
  }
}
@media only screen and (max-width: 600px) {
  .player-registration {
    max-width: 600px;
    width: 100%;
  }
}
</style>
